<template src="./MaintenanceView.html"></template>
<script>
  export default{
    name:'MaintenanceView'
  }
</script>